var map = {
	"./para": [
		"OAIf",
		0
	],
	"./para.json": [
		"OAIf",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8xTr";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/libs/static/uf/seeds lazy ^\.\/.*$
// module id = 8xTr
// module chunks = 5